import axios from "axios";
import toQueryString from "../common/utils/to-query-string";

const get = (query) => axios.get(toQueryString("api/v1/scores?", query));

const add = (points) => axios.post("api/v1/scores", points);

const update = (list) => axios.put(`api/v1/scores`, { list });

const remove = (id) => axios.delete(`api/v1/scores/${id}`);

// LF360-1872 — the project's own explanation of LifePoints. It lives on the project
// settings row, not among the scores, because there is one of it per project.
const getDescription = () =>
  axios.get("api/v1/settings/life-points-description");

const updateDescription = (lifePointsDescription) =>
  axios.put("api/v1/settings/life-points-description", { lifePointsDescription });

const ApiLifePointsManagement = {
  get,
  add,
  update,
  remove,
  getDescription,
  updateDescription,
};

export default ApiLifePointsManagement;
